import { OfflinePurchase } from '@@types'
import { useEffect, useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { useFetchSingleOfflinePurchase } from '@entities/Order/hook/singleOfflinePurchase.gql'

import OfflineOrderItem from '@widgets/offline-order-item'
import OrderItemPreviewList from '@widgets/order-item-preview-list'

import Wrapper from '@shared/ui/wrapper'

import OfflineOrderHeader from './OfflineOrderHeader'
import OfflineOrderSummary from './OfflineOrderSummary'

import styles from './styles.module.scss'


interface OfflineOrderCardProps {
  data: OfflinePurchase;
  isInitialOpen?: boolean;
}

export default function OfflineOrderCard ({ data, isInitialOpen }: OfflineOrderCardProps) {
  const [ isDetail, setIsDetail ] = useState(isInitialOpen ?? false)
  const [ wasOpened, setWasOpened ] = useState(isInitialOpen ?? false)

  useEffect(() => {
    if (isDetail && !wasOpened) {
      setWasOpened(true)
    }
  }, [ isDetail, wasOpened ])

  const { purchase, loading } = useFetchSingleOfflinePurchase({
    id: data.id,
    skip: !wasOpened,
    fetchPolicy: 'cache-and-network'
  })

  const handleDetailClick = () => {
    setIsDetail((prev) => !prev)
  }

  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <OfflineOrderHeader
          order={data}
          isDetail={isDetail}
          handleDetailClick={handleDetailClick}
        />

        {isDetail ? (
          loading ? (
            <SkeletonTheme>
              <Skeleton count={1} height={120} style={{ borderRadius: 16 }} />
            </SkeletonTheme>
          ) : purchase?.positions &&
            purchase?.positions?.length > 0 ? (
              <div className={styles.root__items}>
                {purchase.positions.map((el) => (
                  <OfflineOrderItem
                    key={el?.id}
                    data={el}
                  />
                ))}
              </div>
            ) : null
        ) : (
          <OrderItemPreviewList items={purchase?.positions} />
        )}

        {isDetail && purchase && <OfflineOrderSummary data={purchase} />}

      </Wrapper>
    </div>
  )
}